import PerfectScrollbar from 'perfect-scrollbar';
import React, { ReactNode, RefObject, useEffect, useState } from 'react';
import './style.scss';

interface PropsType {
    list: unknown;
    children: ReactNode;
    id?: string;
    divRef?: RefObject<HTMLDivElement>;
}

const ScrolledCard = ({ list, children, id, divRef }: PropsType) => {
    const [perfectScrollbar, setPerfectScrollbar] = useState<PerfectScrollbar>();

    const element = id || 'scrolled-card';

    useEffect(() => {
        setPerfectScrollbar(new PerfectScrollbar(`#${element}`, { wheelPropagation: false }));
    }, []);

    const updatePerfectScrollbar = () => {
        if (perfectScrollbar) {
            setTimeout(() => {
                perfectScrollbar.update();
            }, 500);
        }
    };

    useEffect(() => {
        updatePerfectScrollbar();
    }, [list]);

    return (
        <div className="scrolled-card" id={element} ref={divRef}>
            {children}
        </div>
    );
};

export default ScrolledCard;
